import React from "react"
import { Link, StaticQuery, graphql } from 'gatsby'

export default function MagazineMainNav() {
  return (
    <StaticQuery
      query={graphql`
        query MagazineMainNavQuery {
          allCategoryJson(sort: {order: ASC, fields: sortOrder}) {
            nodes {
              id
              nameJA
              nameEN
              categoryId
              slug
            }
          }
        }
      `}
      render={(data) => {
        const navs = data.allCategoryJson.nodes.map((node) => {
          let uri = '/category/' + node.slug

          return (
              <Link to={uri}><li>{node.nameJA}</li></Link>
          )
        })

        return (
          <>
            <nav className="magazine-main-nav-pc wrapper">
              <ul>
                <Link to="/"><li>すべて</li></Link>
                {navs}
              </ul>
            </nav>
            <nav className="magazine-main-nav-sp">
              <details>
                <summary>
                  カテゴリー
                </summary>
                <div className="menu-data">
                  <ul>
                    <Link to="/"><li>すべて</li></Link>
                    {navs}
                  </ul>
                </div>
              </details>
            </nav>
          </>
        )
      }}          
    />
  )
}
